import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.interceptors.request.use(config => {
    var token = sessionStorage.getItem('token')
    if (token)
        config.headers['Authorization'] = 'Bearer ' + token
    return config
})

Vue.use(VueAxios, axios)
